
import axios, { Canceler } from 'axios';
import { IUsers } from '../interfaces/Users/IUsers';

const clientAPI = axios.create();

clientAPI.defaults.baseURL = process.env.VUE_APP_MYBASE_URL + '/api/';
clientAPI.defaults.headers.common['Cache-Control'] = 'no-cache, no-store, must-revalidate';
clientAPI.defaults.headers.common.Pragma = 'no-cache';
clientAPI.defaults.headers.common.Expires = '0';

export { clientAPI };
export default class API {

    public static async getUsers() {
        const response = (await clientAPI.get("/user/users")).data;

        if (response.success) {
            return response.data as IUsers[];
        } else {
            throw new Error(response.data);
        }
    }
    public static async getUser(userId: any) {
        
        const response = (await clientAPI.get("/user/getuser/" + userId)).data;

        if (response.success) {
            return response.data as IUsers[];
        } else {
            throw new Error(response.data);
        }
    }
   /* public static pushUser(user: any) {
        return clientAPI.post("/user", user);
    }*/


    public static async pushUser(user: any) {
        const result = (
            await clientAPI.post("/user", user)
        ).data;
        console.log(result);
        if (result.success) {
            return result.data as string;
        } else {
            throw new Error(result.errors);
        }
    }

    public static async  deleteUser(userId: any) {
        const deleteResult = (await clientAPI.delete("/user/delete/" + userId)).data;
        console.log(deleteResult);
     
        
    }
}